// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1RmiU","colMaxWidth":"Table_colMaxWidth__1LU0p"};